import * as React from 'react';
import styled from 'styled-components';
import { withMedia } from 'react-media-query-hoc';

import { BREAK_POINTS, COLOURS } from '../../consts/style';
import { ButtonAction } from '../Button';
import { Heading1 } from '../Text';
import { PostCodeInput } from '../FindPlan/FindPlan';
import { InlineSvg } from '../Svg';

const BannerH1 = styled(Heading1.withComponent('h2'))`
  margin: 0 0 24px 0;
  @media (min-width: ${BREAK_POINTS.MIN.MD}) {
    margin: 0 0 32px 0;
  }
`;

const SignUpContainer = styled.section`
  padding: 32px 16px 0px 16px;
  box-sizing: border-box;
  max-width: 1140px;
  justify-content: center;
  width: 100%;

  @media (min-width: ${BREAK_POINTS.MIN.XS}) {
    align-items: center;
    display: flex;
    padding: 0px 0px;
    height: auto;
  }

  @media (min-width: ${BREAK_POINTS.MIN.MD}) {
    justify-content: flex-start;
  }
`;

const SignUpInner = styled.div`
  margin-top: auto;
  display: inline-block;
  width: 100%;
  text-align: center;

  @media (min-width: ${BREAK_POINTS.MIN.XS}) {
    width: 50%;
  }
`;

const SignUpInner2 = styled.div`
  display: inline-block;

  box-sizing: border-box;

  width: 100%;

  @media (min-width: ${BREAK_POINTS.MIN.XS}) {
    width: 50%;
    padding: 32px 16px;
  }

  @media (min-width: ${BREAK_POINTS.MIN.LG}) {
    padding: 48px 16px;
  }
`;

const FlexContainer = styled.div`
  margin: none;
  @media (min-width: ${BREAK_POINTS.MIN.XS}) {
    margin: auto;
    max-width: 348px;
  }
`;

const SignUpInner3 = styled.div`
  display: inline-block;
  width: 100%;
  text-align: center;
  margin-top: 16px;

  @media (min-width: ${BREAK_POINTS.MIN.XS}) {
    width: 50%;
  }
`;

export interface mediaProps {
  mobile: boolean;
  xlarge: boolean;
  large: boolean;
  tablet: boolean;
  desktop: boolean;
}

interface SignUpPureProps {
  headline: string;
  byline: string;
  buttonText: string;
  buttonLink: string;
  bannerImageTitle: string;
  bannerImageSVG: string;
  media: mediaProps;
  onChange?: (e: any) => void;
  onKeyPress?: (e: any) => void;
  onSubmit?: (value: string) => void;
  onFocus?: () => void;
  onBlur?: () => void;
  postCodeValue: string;
  active: boolean;
}

const PostCodeLabel = styled.div`
  font-weight: 600;
  font-size: 14px;
  margin-bottom: 16px;
`;

const SVGContainer = styled.div`
  max-height: 376px;
  max-width: 376px;
  margin: auto;
  margin-bottom: -3px;
  height: 0;
  padding-top: 69%;

  @media (min-width: ${BREAK_POINTS.MIN.XS}) {
    padding-top: 100%;
  }

  @media (min-width: ${BREAK_POINTS.MIN.SM}) {
    padding-top: 78%;
  }
  @media (min-width: ${BREAK_POINTS.MIN.MD}) {
    padding-top: 66%;
  }

  position: relative;

  svg {
    position: absolute;
    top: 0;
    left: 0;
  }
`;

export const RippleLine = ({ active }) => {
  return (
    <div
      style={{
        backgroundColor: `${COLOURS.SECONDARY.BLUE}`,
        position: 'relative',
        top: '-4px',
        bottom: 0,
        left: 0,
        width: '241px',
        height: '4px',
        marginBottom: '24px',
        transform: active ? `scaleX(1)` : `scaleX(0)`,
        transition:
          'transform 180ms cubic-bezier(0.4, 0, 0.2, 1), opacity 180ms cubic-bezier(0.4, 0, 0.2, 1)',

        opacity: active ? 1 : 0,
      }}
    />
  );
};

export const SignUpPure = withMedia(
  ({
    media,
    headline,
    byline,
    buttonText,
    bannerImageTitle,
    bannerImageSVG,
    onChange,
    onKeyPress,
    postCodeValue,
    onSubmit,
    onFocus,
    onBlur,
    active,
  }: SignUpPureProps) => (
    <SignUpContainer data-comment="SignUpContainer">
      <SignUpInner>
        {!media.mobile && (
          <SVGContainer>
            <InlineSvg title={bannerImageTitle} html={bannerImageSVG} />
          </SVGContainer>
        )}
      </SignUpInner>
      <SignUpInner2>
        <FlexContainer>
          <BannerH1>{headline}</BannerH1>

          <PostCodeLabel>{byline}</PostCodeLabel>

          <PostCodeInput
            value={postCodeValue}
            onChange={onChange}
            onKeyPress={onKeyPress}
            onFocus={onFocus}
            onBlur={onBlur}
            inputmode="numeric"
            pattern="[0-9]*"
            title="Postal Code"
            placeholder={3000}
            maxlength={4}
            type="tel"
          />
          <RippleLine active={active} />

          <ButtonAction onClick={onSubmit!}>{buttonText}</ButtonAction>
        </FlexContainer>
      </SignUpInner2>
      {media.mobile && (
        <SignUpInner3>
          <SVGContainer>
            <InlineSvg title={headline} html={bannerImageSVG} />
          </SVGContainer>
        </SignUpInner3>
      )}
    </SignUpContainer>
  ),
);
